import { createFileRoute } from '@tanstack/react-router'
import { Accounting } from '@/pages/Accounting'

export const Route = createFileRoute('/accounting')({
  component: Accounting,
})
